import styled from 'styled-components';

const FormWrapper = styled.div`
  height: 100%;
  display: inline-grid;
  align-items: ${({ align }) => align || null};
  grid-template-rows: ${({ gridStyling }) => gridStyling || '1fr auto'};
`;

export default FormWrapper;
